import AssetTypesTable from './assetTypesTable'

export default AssetTypesTable
